import ArrowRightIcon from "@heroicons/react/20/solid/ArrowRightIcon";
import BookmarkFilledIcon from "@heroicons/react/24/solid/BookmarkIcon";
import SparklesIcon from "@heroicons/react/24/solid/SparklesIcon";
import LinkIcon from "@mui/icons-material/Link";
import { Button, ButtonBase } from "@mui/material";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { styled as styling } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import Link from "next/link";
import { LinkedinShareButton, TwitterShareButton } from "react-share";
import styled from "styled-components";
import Color from "../../../assets/colors";
import { FontSize } from "../../../assets/font";

export const useStyles = makeStyles((theme) => ({
  root: {
    "& img": {
      // Overwrite CMS inline style for image width
      width: "100% !important",
      maxWidth: "100%",
    },
  },
}));

// Icon Components //
export const LinkIconStyled = styling(LinkIcon)({
  color: Color.white,
  fontSize: FontSize.desktopHeadline,
  margin: "0",
});

export const LinkedinIconStyled = styling(LinkedinShareButton)({
  marginLeft: "2rem",
});

export const TwitterIconStyled = styling(TwitterShareButton)({
  marginLeft: "2rem",
});

// Grid Components //
export const ArticleWrapper = styling(Grid)({
  display: "flex",
  flexDirection: "row",
  width: "100%",
  height: "100%",
  padding: "40px 100px",
  gap: "40px",
  alignItems: "flex-start",
  alignSelf: "stretch",

  "@media(max-width: 1279.9px)": {
    padding: "40px 24px",
    gap: "16px",
  },
});

export const GridContent = styling(Grid)({
  marginBottom: "40px",
});

export const GridArticleDetails = styling(Grid)({
  margin: "0 0 1.25rem 0",
});

export const GridShareIcons = styling(Grid)({
  margin: "0 0 1.25rem 0",
  display: "flex",
});

export const GridArticleContent = styling(Grid)({
  margin: "0 0 1.25rem 0",
});

export const GridTitle = styling(Grid)({
  margin: "0 0 1.25rem 0",
});

export const GridShortDescription = styling(Grid)({
  margin: "0 0 1.25rem 0",
});

export const ContainerTitle = styling(Grid)({
  display: "flex",
  alignItems: "baseline",
  justifyContent: "space-between",
});

export const CustomIconContainer = styling(Grid)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "50px",
  background: Color.darkGrey,
  cursor: "pointer",
  width: "32px",
  height: "32px",
  marginLeft: "2rem",
});

export const SimilarArticleWrapper = styling(Grid)({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "16px",
  overflow: "visible",
  width: "100%",
  maxWidth: "1040px",
});

export const SimilarArticleContainer = styling(Grid)({
  display: "flex",
  flexDirection: "row",
  gap: "16px",

  overflowY: "scroll",

  "::-webkit-scrollbar": {
    display: "none",
  },

  "@media(min-width: 1280px)": {
    width: "1040px",
    // height: "350.5488px",
  },

  "@media(max-width: 1279px)": {
    // paddingRight: "24px",
    // width: "calc(100vw - 24px)",
    // height: "350.5488px",
  },

  "@media(max-width: 767.99px)": {
    width: "calc(100vw - 24px)",
    gap: "8px",
    // height: "299.638px",
  },
});

// Typography Components //
export const TitleStyled = styling("h1")({
  fontWeight: "bold",
  textTransform: "capitalize",
  fontSize: "2.25rem",
  margin: "0 0 1.25rem 0",
});

export const ShortDescription = styling(Typography)({
  fontSize: "1.25rem",
  margin: "0 0 1.25rem 0",
});

export const ArticleDetails = styled(Typography)`
  && {
    font-size: 0.75rem;
    font-style: ${(props) => (props.$italic ? "italic" : null)};
  }
`;

export const ArticleContent = styling(Typography)({
  fontSize: "1rem",
  letterSpacing: "0.02rem",
  margin: "0 0 1.25rem 0",

  "& .cta-button-primary": {
    background: Color.hiredlyPurple,
    borderRadius: "2rem",
    height: "3rem",
    color: Color.white,
    fontWeight: "bold",
    width: "12.5rem",
    fontSize: "1rem",
    textAlign: "center",
    padding: "0.75rem 1.25rem",
    cursor: "pointer",

    "& a": {
      color: Color.white,
      textDecoration: "none",
    },
  },

  "& .cta-button-secondary": {
    background: Color.white,
    borderRadius: "2rem",
    height: "3rem",
    color: Color.hiredlyPurple,
    fontWeight: "bold",
    width: "12.5rem",
    fontSize: "1rem",
    textAlign: "center",
    padding: "0.625rem 1.25rem",
    cursor: "pointer",
    border: `1px solid ${Color.hiredlyPurple}`,

    "& a": {
      color: Color.hiredlyPurple,
      textDecoration: "none",
    },
  },
});

export const ArticleExcerpt = styled(Typography)`
  && {
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    display: -webkit-box;
    white-space: break-spaces;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
`;

export const SimilarTitle = styled(Typography)({
  "&&": {
    color: "#40249B",
    //textAlign: "center",
    fontFamily: "Inter",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "24px",

    "@media(max-width: 767.99px)": {
      fontSize: "17px",
    },
  },
});

// Container Component //
export const ContainerStyled = styling(Container)({
  paddingBottom: "24px",
});

// Footer Components //
export const FooterGridContent = styling(Grid)({
  backgroundColor: Color.lightGrey,
});

export const ArticleGrid = styling(Grid)((props) => ({
  maxWidth: "44rem",
  // margin: "2rem auto 0 auto",
  width: "100%",
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "flex-start",

  [props.theme.breakpoints.down(480)]: {
    margin: "2rem 20px",
  },
}));

export const ArticleSimilarGrid = styling(Grid)({
  display: "flex",
  padding: "0px 100px 40px 100px",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "40px",
  alignSelf: "stretch",
  width: "100%",
  height: "100%",

  overflow: "hidden",

  "@media(min-width: 1280px)": {
    padding: "0px 100px 80px 100px",
  },

  "@media(max-width: 1279.9px)": {
    padding: "0px 24px 40px 24px",
  },

  "@media(max-width: 480px)": {
    padding: "0px 16px 40px 16px",
  },
});

export const FooterCardContent = styling(Grid)((props) => ({
  display: "grid",
  gridTemplateColumns: "auto auto auto",
  gap: "55px",
  margin: "1.25rem 0 0",

  [props.theme.breakpoints.down(480)]: {
    display: "grid",
    gridTemplateColumns: "auto",
  },

  [props.theme.breakpoints.down(780)]: {
    gap: "0",
  },
}));

export const FooterTitle = styling(Typography)({
  fontWeight: "bold",
  fontSize: "1.25rem",
  paddingTop: "1rem",
});

export const CardStyled = styling(Card)((props) => ({
  backgroundColor: "transparent",

  [props.theme.breakpoints.down(480)]: {
    minWidth: "100%",
  },
}));

export const CardMediaStyled = styling(CardMedia)({
  height: "150px",
  borderRadius: "0.75rem",
});

export const CardActionAreaStyled = styling(CardActionArea)({
  height: "100%",
});

export const CardContentStyled = styling(CardContent)({
  padding: "0.75em 0 0.75em 0.25em",
});

export const JobTitle = styled(Typography)`
  && {
    font-weight: bold;
    font-size: 1rem;
    text-transform: capitalize;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    display: -webkit-box;
    white-space: break-spaces;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
`;

// Image Component //
export const ImageStyled = styling("img")({
  width: "100%",
  position: "absolute",
  objectFit: "cover",
  top: "0",
  height: "100%",
});

// Box Component //
export const ImageContainer = styling(Box)((props) => ({
  width: "100%",
  overflow: "hidden",
  position: "relative",
  paddingTop: "30%",

  [props.theme.breakpoints.down(480)]: {
    paddingTop: "50%",
  },
}));

export const AdPlacement = styling(Box)((props) => ({
  aspectRatio: "3/1",
  position: "relative",
}));

export const ImageAdBanner = styling("img")({
  width: "100%",
  maxWidth: "100%",
});

export const LinkStyled = styling("a")((props) => ({
  //
}));

export const SimilarLinkStyled = styling(Link)({
  textDecoration: "none",
});

// Divider //
export const StyledDivider = styling(Box)({
  width: "100%",
  height: "0.1px",
  background: "#D8D8D8",
});

// Similar Article Component //
export const StyledSimilarCard = styling(Card)((props) => ({
  width: "auto",
  margin: "0",
  height: "100%",
  minWidth: "336px",
  background: "none",

  "& .MuiButtonBase-root": {
    flexDirection: "column",
    width: "100%",
  },

  "&.MuiPaper-elevation1": {
    boxShadow: "none",
  },

  [props.theme.breakpoints.down(780)]: {
    "& .MuiButtonBase-root": {
      width: "100%",
    },
  },

  [props.theme.breakpoints.down(480)]: {
    "& .MuiButtonBase-root": {
      width: "100%",
    },
  },
}));

export const StyledSimilarCardMedia = styling(CardMedia)((props) => ({
  borderRadius: "8px",
  height: "100%",
  width: "100%",
  maxHeight: "202.22px",
  minHeight: "200px",
}));

export const StyledSimilarCardActionArea = styling(CardActionArea)((props) => ({
  width: "100%",
  height: "100%",
  display: "flex",
  padding: "16px",
  borderRadius: "8px",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: "31px",
  border: "0.5px solid #AEAEAE",
  background: "#FFF",

  [props.theme.breakpoints.down(780)]: {
    flexDirection: "column",
  },

  [props.theme.breakpoints.down(480)]: {
    flexDirection: "column",
  },
}));

export const StyledSimilarCardContent = styling(CardContent)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  width: "100%",
  marginBottom: "auto",
  padding: "0px",
  gap: "16px",
});

export const BlogTitle = styling(Typography)({
  fontWeight: "bold",
  fontSize: "16px",
  textTransform: "capitalize",

  overflow: "hidden",
  textOverflow: "ellipsis",
  width: "100%",
  display: "-webkit-box",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical",
  whiteSpace: "break-spaces",
  margin: 0,
});

export const SimilarArticleExcerpt = styling(Typography)({
  overflow: "hidden",
  textOverflow: "ellipsis",
  width: "100%",
  display: "-webkit-box",
  WebkitLineClamp: 3,
  WebkitBoxOrient: "vertical",
  whiteSpace: "break-spaces",
  padding: 0,
  margin: 0,

  "&.MuiTypography-root > p": {
    margin: 0,
  },
});

export const ViewOtherButtonContainer = styling(Grid)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
});

export const ViewOtherButton = styling(Button)({
  "&&": {
    height: "42px",
    minWidth: "200px",
    padding: "0 16px",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "100px",
    background: "#512ACC",

    ":hover": {
      background: "#40249B",
    },

    "@media(max-width: 767px)": {
      height: "36px",
      minWidth: "160px",
    },

    "&.MuiButton-text": {
      color: "#FFFFFF",
      fontFamily: "Inter",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "normal",
      textTransform: "none",

      "@media(max-width: 767px)": {
        fontSize: "14px",
      },
    },
  },
});

// Advice article directory //

export const DirectoryGrid = styling(Grid)({
  display: "flex",
  width: "240px",
  height: "fit-content",
  flexDirection: "column",
  gap: "16px",
});

export const DirectoryTitle = styling(Typography)({
  "&&": {
    color: "#000000DE",
    fontFamily: "Inter",
    fontSize: "10px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
    letterSpacing: "1.5px",
    textTransform: "uppercase",
    textWrap: "wrap",
  },
});

export const DirectoryCTAText = styling(Typography)({
  "&&": {
    color: "#000000DE",
    fontFamily: "Inter",
    fontSize: "12px",
    fontStyle: "normal",
    lineHeight: "20px",
    fontWeight: 400,
  },
});

export const TitleCTAGrid = styling(Grid)({
  display: "flex",
  width: "100%",
  gap: "16px",
  alignItems: "center",
});

export const StyledBar = styling(Box)({
  width: "3px",
  height: "32px",
  background: "#222222",
  borderRadius: "10px",
});

export const StyledArrow = styling(ArrowRightIcon)({
  width: "20px",
  height: "20px",
});

export const JobListContainer = styling("div")({
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  gap: "16px",
  width: "100%",
  overflow: "hidden",

  "@media (max-width: 1279px)": {
    gridTemplateColumns: "repeat(2, 1fr)",
  },

  "@media (max-width: 640px)": {
    display: "flex",
    overflowY: "hidden",
    overflowX: "auto",
    scrollBehavior: "smooth",
    scrollSnapType: "x mandatory",
    gap: "8px",

    "-webkit-scrollbar, ::-webkit-scrollbar": {
      display: "none",
    },
  },
});

export const LinkWrapper = styling(Link)({
  textDecoration: "none",
});

export const JobCard = styling("div")({
  backgroundColor: Color.white,
  border: `0.5px solid #AEAEAE`,
  borderRadius: "8px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",

  height: "120px",
  width: "100%",
  padding: "10px 10px 14px 10px",
  minWidth: 0,
  maxWidth: "366px",

  "@media (max-width: 1279px)": {
    maxWidth: "100%",
  },

  "@media (max-width: 640px)": {
    height: "148px",
    width: "280px",

    scrollSnapAlign: "center",
    scrollSnapStop: "always",
  },
});

export const BoxContainer = styling(Box)({
  display: "flex",
});

export const JobTitleCard = styling("h3")({
  color: Color.textMediumEmphasis,

  flex: "1 1 auto",

  fontSize: "0.875rem",
  fontWeight: "700",
  lineHeight: "24px",
  letterSpacing: "0.1px",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  overflow: "hidden",

  margin: "0",
  width: "100%",
  maxWidth: "270px",

  "@media (max-width: 1279px)": {
    maxWidth: "430px",
  },

  "@media (max-width: 640px)": {
    maxWidth: "100%",
  },
});

interface JobDetailChipProps {
  type?: "jobType" | "state" | "salary";
}

export const JobDetailChip = styling("span")<JobDetailChipProps>((props) => ({
  background: Color.backgroundGrey,
  color: Color.textMediumEmphasis,
  borderRadius: "0.25rem",

  fontSize: "0.625rem",
  fontWeight: "700",
  textWrap: "nowrap",

  height: "21px",
  padding: "0.1875rem 0.62rem",

  "@media (max-width: 640px)": {
    ...(props.type === "jobType" && {
      color: Color.blue,
      backgroundColor: "rgba(33, 61, 181, 0.14)",
    }),
    ...(props.type === "state" && {
      color: "rgba(129, 155, 72, 1)",
      backgroundColor: "rgba(129, 155, 72, 0.14)",
    }),
    ...(props.type === "salary" && {
      color: "rgba(155, 72, 72, 1)",
      backgroundColor: "rgba(155, 72, 72, 0.14)",
    }),
  },
}));

export const JobBoostChip = styling("span")({
  background: Color.lightHiredlyPurple,
  color: Color.darkPurple,
  borderRadius: "0.25rem",
  border: `1px solid ${Color.darkPurple}`,

  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  flexShrink: 0,

  fontSize: "0.625rem",
  fontWeight: "400",
  lineHeight: "20px",
  letterSpacing: "1.5px",
  textTransform: "uppercase",

  height: "20px",
  width: "51px",
  padding: "0px 5px",
  margin: "0 0 0 8px",
});

export const SparklesIconStyled = styling(SparklesIcon)({
  width: "10px",
  height: "10px",
});

export const ChipContainer = styling("div")({
  display: "flex",
  flexWrap: "wrap",
  gap: "0.375rem",

  height: "100%",
  marginBottom: "14px",
});

export const CompanyDetailContainer = styling("div")({
  display: "flex",
  alignItems: "center",
  gap: "0.75rem",

  width: "calc(100% - 24px)",
});

export const CompanyLogo = styling("img")({
  objectFit: "contain",

  borderRadius: "0.375rem",
  boxShadow: "0px 1px 4px 0px rgba(0, 0, 0, 0.25)",

  height: "26px",
  width: "26px",
});

export const CompanyName = styling("h4")({
  color: Color.textMediumEmphasis,

  flex: "1 1 auto",

  fontSize: "0.625rem",
  fontWeight: "400",
  lineHeight: "20px",
  letterSpacing: "1.5px",
  textTransform: "uppercase",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  overflow: "hidden",

  margin: "0",
  maxWidth: "calc(100% - 30px)",
});
export const BookmarkButton = styling(ButtonBase)((props) => ({
  borderRadius: "0.25rem",
  flexShrink: 0,
  width: "24px",

  transition: "all 0.15s ease-in-out",

  ...(props.disabled && {
    pointerEvents: "none",
    cursor: "not-allowed",
    opacity: "0.5",
  }),
}));

export const SaveIcon = styling(BookmarkFilledIcon)({
  color: Color.white,
  stroke: Color.hiredlyPurple,
  strokeWidth: "2",

  height: "20px",
  width: "20px",

  transition: "all 0.15s ease-in-out",
  "&:hover": {
    strokeWidth: "2.5",
  },
});

export const UnsaveIcon = styling(BookmarkFilledIcon)({
  height: "20px",
  width: "20px",
  strokeWidth: "2",

  transition: "all 0.15s ease-in-out",

  "&:hover": {
    strokeWidth: "2.5",
  },
});
